import { defineStore } from 'pinia'

interface UIState {
  showSwitcher: boolean
  showApps: boolean
  showCmd: boolean
  showTweaks: boolean
  showProfile: boolean
  showAskAi: boolean
}

export const useUIStore = defineStore('ui', {
  state: (): UIState => ({
    showSwitcher: false,
    showApps: false,
    showCmd: false,
    showTweaks: false,
    showProfile: false,
    showAskAi: false,
  }),
  actions: {
    openSwitcher() {
      this.showSwitcher = true
    },
    closeSwitcher() {
      this.showSwitcher = false
    },
    openApps() {
      this.showApps = true
    },
    closeApps() {
      this.showApps = false
    },
    openCmd() {
      this.showCmd = true
    },
    closeCmd() {
      this.showCmd = false
    },
    openTweaks() {
      this.showTweaks = true
    },
    closeTweaks() {
      this.showTweaks = false
    },
    openProfile() {
      this.showProfile = true
    },
    closeProfile() {
      this.showProfile = false
    },
    openAskAi() {
      this.showAskAi = true
    },
    closeAskAi() {
      this.showAskAi = false
    },
    closeAll() {
      this.showSwitcher = false
      this.showApps = false
      this.showCmd = false
      this.showTweaks = false
      this.showProfile = false
      this.showAskAi = false
    },
  },
})
